import { useEffect, useState } from "react";
import { API } from "@services/http.service";

/**
 * Yasal metinleri (Aydınlatma Metni, Çerez Politikası, Kişisel Veriler Bildirimi,
 * Ticari Elektronik İleti İzni) admin panelinden yönetilen içerikten dinamik
 * olarak çeker ve gösterir.
 *
 * Metin, token GEREKTİRMEYEN public endpoint'ten alınır; böylece login / kayıt /
 * çerez politikası gibi giriş yapılmamış sayfalarda da çalışır:
 *   GET /profile/public/pageDescription?type=<TYPE>
 *
 * İçerik admin tarafından TinyMCE ile HTML olarak kaydedildiği için
 * dangerouslySetInnerHTML ile basılır. Kayıt yoksa (admin henüz girmemişse)
 * hiçbir şey render edilmez.
 *
 * @param {string} type   LEGAL_TEXT_TYPES içindeki tip anahtarı.
 * @param {string} className  Sarmalayan div'e uygulanacak sınıf(lar).
 */

// Aynı tip birden çok modalda/sayfada kullanılabildiğinden, oturum boyunca
// tekrar tekrar istek atmamak için basit bir bellek içi önbellek.
const cache = new Map();

const fetchLegalText = async (type) => {
  if (cache.has(type)) return cache.get(type);
  try {
    const response = await API.get(
      `/profile/public/pageDescription?type=${type}`
    );
    const description = response?.data?.description || "";
    cache.set(type, description);
    return description;
  } catch (error) {
    return "";
  }
};

const LegalText = ({ type, className = "agreement-content" }) => {
  const [description, setDescription] = useState(() => cache.get(type) || "");

  useEffect(() => {
    let active = true;
    if (!type) return undefined;

    fetchLegalText(type).then((content) => {
      if (active) setDescription(content);
    });

    return () => {
      active = false;
    };
  }, [type]);

  if (!description) return null;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

export default LegalText;
